import * as React from 'react'
import * as Styles from './TopBanner.style'
// import subscribe_ico from '../../../../assets/subscribed_推文消息.png'
import noSubscribe_ico from '../../../../assets/头图-领取新人红包.png'
import { HttpServer } from '@/services/server'
import { getUrlParam } from '@/utils/tools'
import { appBaseUrl } from '@/config'

interface ITopBannerState {
  subscribed: boolean
  subscribed_retain: boolean
  showSubscribedCode: () => void | null
}

export default class TopBanner extends React.Component<ITopBannerState> {
  public link() {
    const scene = getUrlParam('scene') ? `.${getUrlParam('scene')}` : ''
    const linkUrl = `${appBaseUrl}/coupons-bag/newcomer/usecoupon?couponid=44&inviter_id=64470924&entry=freelecture`
    try {
      HttpServer.reportServerAPI([
        {
          ubt: `wk.opu9${scene}-freelecture.receive_btn`,
          evt: 'click',
          evt_params: {
            inviter_id: getUrlParam('inviter_id'),
            url: linkUrl
          }
        }
      ])
    } catch (err) {
      console.log(err)
    }
    setTimeout(() => {
      window.location.assign(linkUrl)
    }, 100)
  }

  public render() {
    return (
      <div className={Styles.topBanner}>
        {this.props.subscribed || this.props.subscribed_retain ? (
          <div className={Styles.bannerImg} onClick={() => this.link()}>
            <img src="https://staticqc-operating.lycheer.net/image/weike-dinTJB-724697620.png" />
            <img className={Styles.btnImg} src="https://staticqc-operating.lycheer.net/image/weike-JakFbb-372069263.png" alt="" />
          </div>
        ) : (
          <div className={Styles.bannerImg} onClick={this.props.showSubscribedCode}>
            <img className={Styles.NoSubscribeImg} src={noSubscribe_ico} />
            <div className={Styles.topBannerButton}>
              <div className={Styles.topBannerButtonText}>立即领取</div>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/FreeLecture/components/TopBanner/TopBanner.tsx